module.exports = __webpack_public_path__ + "img/emoji_78.57087261.png";